module.exports = __webpack_public_path__ + "static/media/asset_4.1ffd3fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/asset_4.jpg
// module id = 313
// module chunks = 0